module.exports = __webpack_public_path__ + "img/wallet_04_experience.969c1edb.png";